import api from "../../../core/api";
import { ChangeDocument, Document } from "../models/machineDocumentsModel";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.machineryApiBaseUrl };
};

class CustomerMachineDocumentApi {
  getDocuments(machineId: string): Promise<Document[]> {
    return api.get<Document[]>(`v1/customer/machines/${machineId}/documents`, getRequestConfig()).then(x => x.data);
  }

  getDocument(documentId: string): Promise<Document> {
    return api.get<Document>(`v1/customer/machines/${documentId}/documents`, getRequestConfig()).then(x => x.data);
  }

  createDocument(machineId: string, model: ChangeDocument): Promise<void> {
    return api.post(`v1/customer/machines/${machineId}/documents`, model, getRequestConfig());
  }

  changeDocument(documentId: string, model: ChangeDocument): Promise<any> {
    return api.put(`v1/customer/documents/${documentId}`, model, getRequestConfig());
  }

  // NO public/anonymous document exposure — owner ruling 2026-08-13 (D14): documents
  // are login-only. Do not re-add a visibility tick or a public docs list without a new
  // owner ruling. The `setDocumentVisibility` binding on PUT
  // v1/customer/documents/{id}/visibility (B7-BE5) is removed; that route is deleted
  // server-side in the same release.

  deleteDocument(documentId: string): Promise<any> {
    return api.delete(`v1/customer/documents/${documentId}`, getRequestConfig());
  }
}

export default new CustomerMachineDocumentApi();